import API from './api';

export default class Tutorial extends API {}
